module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/201707/top_images/3-bc3be9876255186b8583b6f8f040f306.png";